import { alpha, Pagination as MuiPagination, styled } from '@mui/material'

export const Pagination = styled(MuiPagination)`
  .MuiPaginationItem-root {
    margin: 5px;
    font-weight: 400;

    &.Mui-selected {
      font-weight: 700;
      color: ${({ theme }) => theme.palette.common.black};
      border: 1px solid ${({ theme }) => theme.palette.primary.main};
      border-radius: 4px;
      background: ${({ theme }) => alpha(theme.palette.primary.main, 0.05)};
    }
  }

  .MuiPaginationItem-previousNext {
    color: ${({ theme }) => alpha(theme.palette.common.black, 0.54)};
  }
`
